import { render, staticRenderFns } from "./EnergyPrice.vue?vue&type=template&id=32ef92ec&scoped=true&"
import script from "./EnergyPrice.vue?vue&type=script&lang=ts&"
export * from "./EnergyPrice.vue?vue&type=script&lang=ts&"
import style0 from "./EnergyPrice.vue?vue&type=style&index=0&id=32ef92ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ef92ec",
  null
  
)

export default component.exports